import styles from "./about.module.css";
import Timeline from "./Timeline";

const MyTimeLine = () => {
  return (
    <div id="about" className={styles.main}>
      <h1 className="text_theme">
        About <span className="text-blue">ME</span>
      </h1>
      <div className={styles.about}>
        <img src="./profilePic.jpg" alt="Profile Pic" />
        <div className={styles.about_Des}>
          Hi Everyone, I am <span className="text-blue">Ankit Kumar </span>from{" "}
          <span className="text-blue"> Bhagalpur, Bihar</span>. I have completed
          my graduation in Electronics & Communication Engineering from Narula
          Institute of Technology, Kolkata.
          <br /> <br />I love to work on exciting projects that test what I've
          learnt. I'm always looking for better,
          and more importantly, ethical and accessible ways to solve the common
          problems we are faced with day-to-day.
          <br/>
          
           
          <a
            href="https://www.linkedin.com/in/ankit-kumar-92113b201/" 
            className="btn-blue_active" 
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://github.com/ankitkumar3443" 
            className="btn-blue_active" 
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
        </div>
      </div>
      {/* <h1 className={styles.about + " text_theme"}>
        My <span className="text-blue">TimeLine⌛</span>
      </h1>
      <Timeline/> */}
    </div>
  );
};

export default MyTimeLine;
